
  import {Component, Vue, Watch} from "vue-property-decorator";
  import editConfig from "@/views/camera_apply/editConfig";
  import Enumerable from "linq";
  import {fileToBase64} from "@/utils";

  import DataEmpty from "@/views/components/DataEmpty/DataEmpty.vue";

  @Component({
    name: "index",
    components: {DataEmpty}
  })


  export default class extends Vue {

    private dialogVisible = false;
    private dialogImageUrl = '';
    private cameraItems: GetCameraItem[] = [];
    private selectCameraItems: GetCameraItem[] = [];
    private threeCameraItem: GetCameraItem[] = [];
    private threeSelectCameraItems: GetCameraItem[] = [];
    private fileList = [];
    private inputModel: inputDataModel_AcceptPacket
    private $promptShow = false;
    private getFileList(file, fileList) {
      console.log(fileList);
      this.fileList = fileList;
    }

    private masterFileMax(file, fileList){
      this.$message.warning(`最可添加 6 张图片！`);
    }

    private created(): void {
    }

    private deviceSelectChange(selection) {
      console.log(this.cameraItems)
      this.selectCameraItems = selection;
      console.log(this.selectCameraItems)
    }

    private threeDeviceSelectChange(selection) {
      console.log(this.threeCameraItem)
      this.threeSelectCameraItems = selection;
      console.log(this.threeSelectCameraItems)
    }

    private mounted(): void {

    }

    private editConfig = editConfig;
    private form = {
      devicetype: '',
      devicemanufacturer: '',
      threedevicetype: '',
      threedevicemanufacturer: '',
      contactMobile: '',
      contactPerson: ''
    };

    public imageUrls: string[] = [];

    public picRemove(file, fileList) {
      console.log(file, fileList);
    }

    public pictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }

    //枚举相机
    public getCamera() {
      console.log(this.form.devicetype);
      if ("" == this.form.devicemanufacturer) {
        this.$message("请选择相机厂商！");
        return;
      }
      this.cameraItems.splice(0, this.cameraItems.length);//清空数组
      var cameraListInfo = obj_CameraApplyCore.searchCamera(this.form.devicemanufacturer);
      debugger
      console.log(cameraListInfo);
      var cameraList = JSON.parse(cameraListInfo)
      this.cameraItems = cameraList;
      if ( 0 == this.cameraItems.length)
      {
        this.$message("无可用相机");
      }
    }
    public getCamera1() {
      console.log(this.form.devicetype);
      if ("" == this.form.devicemanufacturer) {
        this.$message("请选择相机厂商！");
        return;
      }
      this.cameraItems.splice(0, this.cameraItems.length);//清空数组
      var  cameraListInfo = "[{\"serialNo\":\"00C34187610\",\"name\":\"刘瑶瑶\"}," +
        "{\"serialNo\":\"00C34187611\",\"name\":\"615\"}," +
        "{\"serialNo\":\"00C34187612\",\"name\":\"615\"}," +
        "{\"serialNo\":\"00C34187613\",\"name\":\"615\"}," +
        "{\"serialNo\":\"00C34187614\",\"name\":\"615\"}," +
        "{\"serialNo\":\"00C34187615\",\"name\":\"615\"}," +
        "{\"serialNo\":\"00C34187616\",\"name\":\"615\"}," +
        "{\"serialNo\":\"00C34187617\",\"name\":\"615\"}," +
        "{\"serialNo\":\"00C34187618\",\"name\":\"615\"}]";

      console.log(cameraListInfo);
      var cameraList = JSON.parse(cameraListInfo)
      this.cameraItems = cameraList;
      if ( 0 == this.threeCameraItem.length)
      {
        this.$message("无可用相机");
      }
    }

    //第三方设备过渡皆苦枚举相机
    public getThreeCamera() {
      if ("" == this.form.threedevicemanufacturer) {
        this.$message("请选择相机厂商！");
        return;
      }
      this.cameraItems.splice(0, this.threeCameraItem.length);//清空数组
      var cameraListInfo = obj_CameraApplyCore.searchCamera(this.form.threedevicemanufacturer);
      var cameraList = JSON.parse(cameraListInfo)
      this.threeCameraItem = cameraList;
      if ( 0 == this.threeCameraItem.length)
      {
        this.$message("无可用相机");
      }
    }

    public getThreeCamera1() {
      console.log(this.form.devicetype);
      if ("" == this.form.threedevicemanufacturer) {
        this.$message("请选择相机厂商！");
        return;
      }
      this.threeCameraItem.splice(0, this.threeCameraItem.length);//清空数组
      var  cameraListInfo = "[{\"serialNo\":\"00C34187601\",\"name\":\"刘瑶瑶2\"}," +
        "{\"serialNo\":\"00C34187602\",\"name\":\"615\"}," +
        "{\"serialNo\":\"00C34187603\",\"name\":\"615\"}," +
        "{\"serialNo\":\"00C34187604\",\"name\":\"615\"}," +
        "{\"serialNo\":\"00C34187605\",\"name\":\"615\"}," +
        "{\"serialNo\":\"00C34187606\",\"name\":\"615\"}," +
        "{\"serialNo\":\"00C34187607\",\"name\":\"615\"}," +
        "{\"serialNo\":\"00C34187608\",\"name\":\"615\"}," +
        "{\"serialNo\":\"00C34187609\",\"name\":\"615\"}]";

      console.log(cameraListInfo);
      var cameraList = JSON.parse(cameraListInfo)
      this.threeCameraItem = cameraList;
      if ( 0 == this.threeCameraItem.length)
      {
        this.$message.warning("无可用相机");
      }
    }

    //调用相机申请接口
    public commitApply() {
      if ("" == this.form.devicetype) {
        this.$message("请勾选相应设备类型");
        return;
      }
      if (0 != this.selectCameraItems.length) {
        var list = Enumerable.from(this.selectCameraItems).select(f => f.serialNo).toArray();
        var result:string = obj_CameraApplyCore.commitApply(list.join(','), this.form.devicemanufacturer,this.form.devicetype);
        debugger
        this.$message.info(result);
        if (-1 !== result.indexOf('成功'))
        {
          this.$promptShow = true;
        }
      } else {
        this.$message("请勾选需要申请的相机！");
      }
    }

    //第三方设备申请
    public async commitThreeDeviceApply() {
      if ("" == this.form.threedevicetype) {
        this.$message("请勾选相应设备类型");
        return;
      }
      if ("" == this.form.contactPerson)
      {
        this.$message("联系人不能为空");
        return;
      }
      if ("" == this.form.contactMobile)
      {
        this.$message("联系人电话不能为空");
        return;
      }
      if (0 == this.fileList.length)
      {
        this.$message("请上传相应设备的图片！");
        return;
      }
      if (0 != this.threeSelectCameraItems.length) {
        var list = Enumerable.from(this.threeSelectCameraItems).select(f => f.serialNo).toArray();
        console.log(list);
        var imgList = [];
        for (let i = 0; i < this.fileList.length; i++) {
          var f = this.fileList[i];
          var base64 =  await fileToBase64(f.raw);
          imgList.push(base64.split(',')[1]);
        }
        console.log(imgList)
        console.log(this.fileList);
        var result:string = obj_CameraApplyCore.threeDeviceApply(list.join(','),this.form.threedevicemanufacturer,this.form.threedevicetype, this.form.contactPerson, this.form.contactMobile, imgList);
        this.$message.info(result);
        debugger
        if (-1 !== result.indexOf('成功'))
        {
          this.$promptShow = true;
        }
      } else {
        this.$message("请勾选需要申请的相机！");
      }
    }
  }
